// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2K2RK","footer":"ReportModalFilter_footer__2vb0p"};